import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { PasswordChangeContainer } from '@/features/settings';

export default function SettingsProfilePasswordPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/settings/profile">
          <Button variant="ghost" size="icon-sm">
            <ChevronLeft className="size-4" />
          </Button>
        </Link>
        <h1 className="text-2xl font-bold tracking-tight">{t('settings.password.title')}</h1>
      </div>

      <div className="max-w-xl">
        <PasswordChangeContainer />
      </div>
    </div>
  );
}
